(()=>{function update(){const forms=[...document.querySelectorAll('[data-oc-signup]')];document.querySelectorAll('[data-oc-nav]').forEach(a=>{a.hidden=!forms.length;if(forms.length)a.setAttribute('href','#'+forms[0].id);});}document.addEventListener('DOMContentLoaded',update);document.addEventListener('shopify:section:load',update);document.addEventListener('shopify:section:unload',()=>setTimeout(update,0));document.addEventListener('shopify:section:reorder',update);})();

(() => {
  function init(root = document) {
    root.querySelectorAll('video[data-oc-loop]').forEach(video => {
      if (video.dataset.ocReady) return;
      video.dataset.ocReady = 'true';
      const button = video.parentElement.querySelector('.oc-video-play');
      video.muted = true;
      video.defaultMuted = true;
      function start() {
        if (!video.dataset.ocLoaded) {
          video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
          video.dataset.ocLoaded = 'true';
          video.load();
        }
        const attempt = video.play();
        if (attempt) attempt.catch(() => { if (button) button.hidden = false; });
      }
      video.addEventListener('playing', () => { if (button) button.hidden = true; });
      if (button) button.addEventListener('click', start);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); start(); }
        }, { rootMargin: '300px' });
        observer.observe(video);
      } else start();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
